import styled from 'styled-components';
import { Button } from '../button';
export const ReadMoreButton = styled(Button) `
  cursor: pointer;
  font-weight: 600;
  padding: 0;
  font-size: 14px;
  line-height: 16px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 16px;
    line-height: 18px;
  }
`;
export const TextLines = styled.span `
  display: -webkit-box;
  -webkit-line-clamp: ${({ limitText, numberOfLines }) => (limitText ? numberOfLines : 'initial')};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
`;
const positionHandler = (position) => {
    const positionOptions = {
        left: 'flex-start',
        right: 'flex-end',
        center: 'center',
    };
    return positionOptions[position || 'left'];
};
export const ContentReadMoreButton = styled.div `
  display: flex;
  justify-content: ${({ position }) => positionHandler(position)};
  margin-top: 8px;
`;
